import { ensureZendeskChat } from '~/composables/useZendeskChat'
import { mergeZendeskSettings } from '~/config/zendeskWidget'

export default defineNuxtPlugin({
  name: 'zendesk-settings',
  enforce: 'pre',
  setup() {
    if (
      import.meta.env.VITE_HISTOIRE === 'true'
        || process.env.HISTOIRE
        || typeof window === 'undefined'
    ) {
      return
    }

    window.zESettings = mergeZendeskSettings(window.zESettings)
    ensureZendeskChat()
  },
})
